import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"bv-truncate\" ...attributes>\n  {{yield}}\n</div>",{ moduleName: "volta/components/bv-truncate/index.hbs" })